export var ImageFit = /*#__PURE__*/ function(ImageFit) {
    ImageFit["COVER"] = "cover";
    ImageFit["CONTAIN"] = "contain";
    return ImageFit;
}({});
export var ImageAlignment = /*#__PURE__*/ function(ImageAlignment) {
    ImageAlignment["LEFT"] = "left";
    ImageAlignment["CENTER"] = "center";
    ImageAlignment["RIGHT"] = "right";
    return ImageAlignment;
}({});

//# sourceMappingURL=image.js.map